import React, { useState, useContext, useEffect, useRef } from 'react'
import '../../css/InputLine.css'
import GlobalStateContext from '../GlobalStateContext'
import SwitchControl from "../ui/Switch";
import { getAlertList } from '../../Funcoes/GetAletrsList'
import { stdValue } from '../../Resources/setNumber';
import ComboLine2 from './ComboLine2';
import ModalUpdateValue from '../ui/ModalUpdateValue';


function CapVapLine2({cod, handleCountChange, options}) {
  const { setAlert, data, setlistAlerts, user, setData, setShowUpdating } = useContext(GlobalStateContext);
 
  const [selectedValue1, setSelectedValue1] = useState(parseInt(data[cod].valor));
  const [selectedValue2, setSelectedValue2] = useState(parseInt(data[cod].op2));
  const [v, setV] = useState(stdValue(data[cod]?.valor))
  const [prevV, setPrevV] = useState('')
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    // console.log('options', options, cod, data[cod].op2 || 1)
    setSelectedValue1(`${parseInt(data[cod]?.valor)}`) 
    setSelectedValue2(`${parseInt(data[cod].op2)}`) 
  }, [ cod, data]);

  const handleAlert = (v) =>{
    setAlert(true)
}

  const handleIpt = (e) => {
    setV(e.target.value)
  }


  const updateValue = async (e) => {
    let nv = e.target.value.replace(/\./g, '')
    nv = nv.replace(/\,/g, '.')
    if (nv === '' || !contemNumero(nv)){
      setV(prevV)
    }else{
      if (nv !== prevV){
        setShowUpdating(true)
        setV(stdValue(nv))
        handleAlert(true)
        setData(prevData => ({
          ...prevData,
          [cod]: {
            ...prevData[cod],
            valor: parseFloat(v),
          },
        }))
        setShowUpdating(false)
        setlistAlerts(getAlertList(data))
      }
    }
    
  }

  const handlePrevV = (e) => {
    setPrevV(e.target.value)
  }

  const updateValue2 = async (val) => {
    setSelectedValue1(val)
    setShowUpdating(true)
  //   console.log(''+val + ': '+cod[2])
  //   await fetch(''+global.endPoint+'/'+user?.uid+'/setValue', {
  //   method: 'PUT',
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   body: JSON.stringify({codigo: cod[2], newValue: val})
  // })
  // .then(response => {
  //   if (!response.ok) {
  //     setShowUpdating(false)
  //     throw new Error('Erro de requisição.');
  //   }else{
      // console.log('updated: '+val)
      setData(prevData => ({
        ...prevData,
        [cod]: {
          ...prevData[cod],
          op2: val
        },
      }))
      // data[cod[2]].valor = val
      setAlert(true)
      handleCountChange(cod)
      setShowUpdating(false)
  //   }
  // })
  // .catch(error => {
  //   setShowUpdating(false)
  //   // Lida com o erro da requisição
  // })
}

  return (
    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
         <div className='inputLineCont'>
            <div className='line'>
                <div className='desc'>{data[cod]?.descricao}</div>
                {/* <div className='iptCont'> */}
                    <input className={`ipt ${data[cod]?.limiteMax !== null && data[cod]?.valor > data[cod]?.limiteMax ? 'outOfLimit' : ''}`} value={v} id={cod} onChange={handleIpt} onBlur={updateValue} onFocus={handlePrevV} type="text" />
                {/* </div> */}
                <div className='unit'>{data[cod]?.unidade}</div>
            </div>
    </div>

    <div style={{width: '22%'}}>
    <ComboLine2 cod={cod} handleCountChange={handleCountChange} />
    
    </div>
            
        <SwitchControl
                descricao={""} name="group-1" callback={(val) => updateValue2(val)} controlRef={useRef()} 
                defaultIndex={selectedValue2} 
                segments={[
                    { label: "0", value: 0, ref: useRef()},
                    { label: "1", value: 1, ref: useRef()}
                ]}
                w={0}
      />
      <ModalUpdateValue show={showModal}><p>Atualizando...</p></ModalUpdateValue>
    </div>
    
  )
}

export default CapVapLine2

function contemNumero(string) {
    return !isNaN(parseFloat(string)) && isFinite(string);
  }